import { batch, connect } from 'react-redux';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';

import {
  actions as filterActions,
  selectTotalFiltersAppliedCount,
  selectTotalSelectedFilterOptionsCount,
} from 'src/components/organisms/Filter';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import type { AppThunkDispatch } from 'src/redux/store';
import {
  updateFilters,
  UpdateFiltersActionType,
} from '../../../../redux/products/thunks/updateFilters';
import { SlimFilterMenu } from '../components/SlimFilterMenu';
import { selectSelectedSortingOptionInSentenceCase } from '../modules/selectors';
import { actions as filterMenuActions } from '../modules/slice';
import type {
  SlimFilterMenuContainerDispatchProps,
  SlimFilterMenuContainerStateProps,
} from '../types';

const mapDispatchToProps = (dispatch: AppThunkDispatch): SlimFilterMenuContainerDispatchProps => ({
  onVisible: () => {
    sendGAEvent({
      event: 'custom_event',
      event_action: 'filter & sort sticky impression',
      event_category: 'Filter & sort',
      event_label: 'icon',
    });
  },
  openFilterModal: ({ totalFiltersAppliedCount, totalSelectedFilterOptionsCount }) => {
    sendGAEvent({
      event: 'custom_event',
      event_category: 'Filters',
      event_action: 'open modal',
      event_label: `number of categories: ${totalFiltersAppliedCount}|number of filters: ${totalSelectedFilterOptionsCount}`,
    });
    dispatch(filterActions.openModal());
  },
  onResetFilters: () => {
    batch(() => {
      dispatch(filterActions.resetFilters());
      dispatch(filterMenuActions.resetSelectedSortOption());
      dispatch(updateFilters(UpdateFiltersActionType.FILTER));
    });
  },
});

const mapStateToProps = (state: ReduxApplicationState): SlimFilterMenuContainerStateProps => ({
  totalFiltersAppliedCount: selectTotalFiltersAppliedCount(state),
  totalSelectedFilterOptionsCount: selectTotalSelectedFilterOptionsCount(state),
  totalProducts: state.products.totalProducts,
  selectedSortOption: selectSelectedSortingOptionInSentenceCase(state),
  pageProductsCount: state.products.productsReturnedCount,
});

export const SlimFilterMenuContainer = connect(mapStateToProps, mapDispatchToProps)(SlimFilterMenu);
